import { render, staticRenderFns } from "./shipmentRecordDetails.vue?vue&type=template&id=2011b44e&scoped=true"
import script from "./shipmentRecordDetails.vue?vue&type=script&lang=js"
export * from "./shipmentRecordDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011b44e",
  null
  
)

export default component.exports